import React, { FC } from 'react';
import { Container } from '../../components/container/container';
import { HeaderTitle } from '../../components/header-title/header-title';
import { ListWrap, WrapTabsNav, BaseTabsNav } from './style';
import { ServicesContainer } from '../services/services.container';
import {
  Tabs,
  TabsContent,
  TabsNav,
  TabsTrigger,
} from '@plataformaxvia/design-system';
import { DepartmentSectionsContainer } from '../../components/department-sections/department-sections.container';

export type ListProps = {
  handleToggle: (hash: string) => void;
  active: string;
};

export const List: FC<ListProps> = ({ handleToggle, active }) => {
  return (
    <>
      <HeaderTitle title="Serviços" />
      <ListWrap>
        <Container>
          <Tabs>
            <WrapTabsNav>
              <BaseTabsNav>
                <TabsNav>
                  <TabsTrigger
                    keepActiveState
                    key="services"
                    href="#services"
                    onToggle={handleToggle}
                    active={active === '#services'}
                  >
                    Serviços
                  </TabsTrigger>
                  <TabsTrigger
                    keepActiveState
                    key="presential"
                    href="#presential"
                    onToggle={handleToggle}
                    active={active === '#presential'}
                  >
                    Atendimento Presencial
                  </TabsTrigger>
                </TabsNav>
              </BaseTabsNav>
            </WrapTabsNav>
            <TabsContent id="services" active={active === '#services'}>
              <ServicesContainer title="Todos" totalServices />
            </TabsContent>
            <TabsContent id="presential" active={active === '#presential'}>
              <DepartmentSectionsContainer title="Atendimento Presencial" />
            </TabsContent>
          </Tabs>
        </Container>
      </ListWrap>
    </>
  );
};
